function clone (object) {
  return JSON.parse(JSON.stringify(object))
}

function randomInt (min, max) {
  return ~~(Math.random() * (max - min + 1)) + min
}

function wait (delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay)
  })
}

function loadImage (src) {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      resolve()
      img = null
    }
    img.onerror = reject
    img.src = src
  })
}

async function loadImages (urls) {
  try {
    await Promise.all(urls.map(url => {
      return loadImage(url)
    }))
  } catch (err) {
    return Promise.reject(err)
  }
}

export default {
  clone,
  randomInt,
  wait,
  loadImage,
  loadImages,
}
